class InspirationSlider extends HTMLElement {
  constructor() {
    super();

    this.initThumbnailsSwiper();
    this.initCoverFlowSwiper();
    this.initCloseButton();
    this.initEscapeKey();
    this.initHoverInfo();
    this.initPictureInPictureButton();
  }

  initHoverInfo() {
    const productItems = this.querySelectorAll(".inspiration-slider__product");

    productItems.forEach((item) => {
      item.addEventListener("mouseover", () => {
        const title = item.getAttribute("data-title");

        const hoverInfoElement = item
          .closest(".inspiration-slider__product-list__wrapper")
          .querySelector("[data-hover-info]");

        hoverInfoElement.textContent = title;
        hoverInfoElement.classList.add(
          "inspiration-slider__hover-info--active"
        );
      });

      item.addEventListener("mouseout", () => {
        const hoverInfoElement = item
          .closest(".inspiration-slider__product-list__wrapper")
          .querySelector("[data-hover-info]");

        hoverInfoElement.classList.remove(
          "inspiration-slider__hover-info--active"
        );
      });

      item.addEventListener("click", (event) => {
        event.preventDefault();

        const handle = item.getAttribute("data-handle");
        const index = item.getAttribute("data-index");
        const quickBuyElement = document.querySelector(
          `inspiration-slider-quick-buy[data-handle="${handle}"][data-index="${index}"]`
        );

        if (quickBuyElement) {
          if (quickBuyElement.classList.contains("active")) {
            quickBuyElement.classList.remove("active");
            return;
          }

          document
            .querySelectorAll("inspiration-slider-quick-buy.active")
            .forEach((element) => {
              element.classList.remove("active");
            });

          quickBuyElement.classList.add("active");
        }
      });
    });

    const hoverInfoElements = this.querySelectorAll("[data-hover-info]");
    hoverInfoElements.forEach((hoverInfoElement) => {
      hoverInfoElement.addEventListener("transitionend", () => {
        if (
          !hoverInfoElement.classList.contains(
            "inspiration-slider__hover-info--active"
          )
        ) {
          hoverInfoElement.textContent = "";
        }
      });
    });
  }

  createTimeline(video) {
    this.progressBarContainer = document.createElement("div");
    this.progressBarContainer.style.position = "absolute";
    this.progressBarContainer.style.top = "0";
    this.progressBarContainer.style.width = "100%";
    this.progressBarContainer.style.height = "5px";
    this.progressBarContainer.style.background = "#D3D3D3";

    this.progressBar = document.createElement("div");
    this.progressBar.style.position = "absolute";
    this.progressBar.style.top = "0";
    this.progressBar.style.height = "5px";
    this.progressBar.style.width = "0";
    this.progressBar.style.background = "#978878";

    this.progressBarContainer.appendChild(this.progressBar);
    video.insertAdjacentElement("afterend", this.progressBarContainer);

    this.progressUpdateHandler = () => {
      const progress = video.currentTime / video.duration;
      this.progressBar.style.width = `${progress * 100}%`;

      if (!video.paused && !video.ended) {
        requestAnimationFrame(this.progressUpdateHandler);
      }
    };

    video.addEventListener("play", this.progressUpdateHandler);
    video.addEventListener("pause", this.progressUpdateHandler);
    video.addEventListener("ended", this.progressUpdateHandler);
  }

  deleteTimeline(video) {
    video.removeEventListener("timeupdate", this.progressUpdateHandler);

    if (this.progressBarContainer) {
      video.parentNode.removeChild(this.progressBarContainer);
      this.progressBarContainer = null;
      this.progressBar = null;
    }
  }

  togglePlayback(video, slide) {
    if (video.paused) {
      video.play();
      const div = slide.parentNode.querySelector(".inspiration-slider__play");
      if (div) {
        div.remove();
      }
    } else {
      video.pause();
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttributeNS(null, "width", "160");
      svg.setAttributeNS(null, "height", "160");
      svg.setAttributeNS(null, "viewBox", "0 0 24 24");
      svg.innerHTML =
        '<path fill="#ffffff" d="M9 15.713V8.287q0-.368.244-.588t.568-.22q.101 0 .213.028q.11.028.212.083l5.842 3.733q.186.13.28.298t.093.379t-.093.379q-.094.167-.28.298l-5.842 3.733q-.102.055-.214.083t-.213.028q-.325 0-.568-.22T9 15.713"/>';

      const div = document.createElement("div");
      div.classList.add("inspiration-slider__play");
      div.appendChild(svg);

      slide.parentNode.appendChild(div);
    }
  }

  initThumbnailsSwiper() {
    this.thumbnailsSwiper = new Swiper(
      this.querySelector(".inspiration-slider__video-thumbnails"),
      {
        slidesPerView: 2.5,
        spaceBetween: 10,
        init: false,
        navigation: {
          nextEl: this.querySelector("[data-thumbnail-next]"),
          prevEl: this.querySelector("[data-thumbnail-prev]"),
        },
        breakpoints: {
          768: {
            slidesPerView: 5,
          },
        },
      }
    );

    this.thumbnailsSwiper.on("init", () => {
      this.thumbnailsSwiper.slides.forEach((slide) => {
        const video = slide.querySelector("video");
        const overlay = slide.querySelector(".inspiration-slider__overlay");
        video.addEventListener("mouseover", () => {
          video.play();
          overlay.classList.add("inspiration-slider__overlay--active");
        });
        video.addEventListener("mouseout", () => {
          video.pause();
          overlay.classList.remove("inspiration-slider__overlay--active");
        });
      });
    });

    this.thumbnailsSwiper.init();
  }

  destroyThumbnailsSwiper() {
    this.thumbnailsSwiper.destroy(true, true);
  }

  initPictureInPictureButton() {
    this.pipButton = this.querySelector("[data-picture-in-picture]");

    this.pipButton.addEventListener("click", () => {
      const activeVideo = this.coverFlowSwiper.slides[this.coverFlowSwiper.activeIndex].querySelector("video");
      if (activeVideo) {
        activeVideo.requestPictureInPicture().catch(console.error);
        this.querySelector(".inspiration-slider__cover-flow").style.opacity = 0;
        this.querySelector(".inspiration-slider__cover-flow").style.visibility = "hidden";
        document.body.style.overflow = "auto";

        activeVideo.addEventListener('leavepictureinpicture', () => {
          this.querySelector(".inspiration-slider__cover-flow").style.opacity = 1;
          this.querySelector(".inspiration-slider__cover-flow").style.visibility = "visible";
          document.body.style.overflow = "hidden";
        });
      }
    });
  }

  initCoverFlowSwiper() {
    this.coverFlowSwiper = new Swiper(this.querySelector("[data-cover-flow]"), {
      grabCursor: true,
      effect: "coverflow",
      centeredSlides: true,
      simulateTouch: false,
      allowTouchMove: false,
      slidesPerView: 1,
      coverflowEffect: {
        depth: 500,
        modifier: 1,
        rotate: 0,
        stretch: 0,
        scale: 0.9,
      },
      navigation: {
        nextEl: this.querySelector("[data-cover-next]"),
        prevEl: this.querySelector("[data-cover-prev]"),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });

    const coverFlowContainer = this.querySelector(".inspiration-slider__cover-flow");
    coverFlowContainer.addEventListener("click", (event) => {
      const clickedElement = event.target;
      const isDescendantOfSlide = clickedElement.closest(".swiper-slide");
      const isDescendantOfNextPrev = clickedElement.closest("[data-cover-next], [data-cover-prev]");
      const isDescentdantOfClose = clickedElement.closest("[data-close-coverflow]");

      if (!isDescendantOfSlide && !isDescendantOfNextPrev && !isDescentdantOfClose) {
        this.pipButton.click();
      }
    });

    const firstVideo = this.coverFlowSwiper.slides[0].querySelector("video");
    if (firstVideo) {
      firstVideo.play();
      this.createTimeline(firstVideo);

      this.initialTogglePlayback = () =>
        this.togglePlayback(firstVideo, firstVideo);
      firstVideo.addEventListener("click", this.initialTogglePlayback);
    }

    this.coverFlowSwiper.on("slideChange", () => {
      document
        .querySelectorAll("inspiration-slider-quick-buy.active")
        .forEach((element) => {
          element.classList.remove("active");
        });

      const oldVideo =
        this.coverFlowSwiper.slides[
          this.coverFlowSwiper.previousIndex
        ].querySelector("video");
      const newVideo =
        this.coverFlowSwiper.slides[
          this.coverFlowSwiper.activeIndex
        ].querySelector("video");

      if (oldVideo) {
        oldVideo.pause();
        this.deleteTimeline(oldVideo);

        if (this.currentTogglePlayback) {
          oldVideo.removeEventListener("click", this.currentTogglePlayback);
        }

        if (
          this.coverFlowSwiper.previousIndex === 0 &&
          this.initialTogglePlayback
        ) {
          firstVideo.removeEventListener("click", this.initialTogglePlayback);
        }

        const svg = this.coverFlowSwiper.slides[
          this.coverFlowSwiper.previousIndex
        ].querySelector(".inspiration-slider__play");
        if (svg) {
          svg.parentNode.removeChild(svg);
        }
      }

      if (newVideo) {
        newVideo.play();
        this.createTimeline(newVideo);

        this.currentTogglePlayback = () =>
          this.togglePlayback(newVideo, newVideo);
        newVideo.addEventListener("click", this.currentTogglePlayback);

        newVideo.addEventListener("enterpictureinpicture", () => {
          this.querySelector(
            ".inspiration-slider__cover-flow"
          ).style.opacity = 0;
          this.querySelector(
            ".inspiration-slider__cover-flow"
          ).style.visibility = "hidden";
          document.body.style.overflow = "auto";
        });

        newVideo.addEventListener("leavepictureinpicture", () => {
          this.querySelector(
            ".inspiration-slider__cover-flow"
          ).style.opacity = 1;
          this.querySelector(
            ".inspiration-slider__cover-flow"
          ).style.visibility = "visible";
          document.body.style.overflow = "hidden";
        });
      }
    });

    this.coverFlowSwiper.slides.forEach((slide, index) => {
      slide.addEventListener("click", () => {
        this.coverFlowSwiper.slideTo(index);
      });
    });

    this.thumbnailsSwiper.on("click", (swiper, event) => {
      this.querySelector(".inspiration-slider__cover-flow").style.opacity = 1;
      this.querySelector(".inspiration-slider__cover-flow").style.visibility =
        "visible";
      document.body.style.overflow = "hidden";

      const clickedIndex = Array.from(swiper.slides).indexOf(
        event.target.closest(".swiper-slide")
      );
      this.coverFlowSwiper.slideTo(clickedIndex, 0);

      const video =
        this.coverFlowSwiper.slides[
          this.coverFlowSwiper.activeIndex
        ].querySelector("video");
      video.play();
    });
  }

  destroyCoverFlowSwiper() {
    this.coverFlowSwiper.destroy(true, true);
  }

  initCloseButton() {
    this.closeButton = this.querySelector(".inspiration-slider__close");

    this.closeButton.addEventListener("click", () => {
      this.querySelector(".inspiration-slider__cover-flow").style.opacity = 0;
      this.querySelector(".inspiration-slider__cover-flow").style.visibility =
        "hidden";
      document.body.style.overflow = "auto";
    });
  }

  initEscapeKey() {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.querySelector(".inspiration-slider__cover-flow").style.opacity = 0;
        this.querySelector(".inspiration-slider__cover-flow").style.visibility =
          "hidden";
        document.body.style.overflow = "auto";
      }
    });
  }
}
customElements.define("inspiration-slider", InspirationSlider);

class InspirationSliderProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 20,
      nested: true,
    });
  }
}
customElements.define("inspiration-slider-products", InspirationSliderProducts);

class InspirationSliderQuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCloseButton();
    this.initAddToCartForm();
    this.initProductOptions();
  }

  initCloseButton() {
    this.closeButton = this.querySelector(
      ".inspiration-slider__quick-buy__close"
    );

    this.closeButton.addEventListener("click", () => {
      this.classList.remove("active");
    });
  }

  initAddToCartForm() {
    this.form = this.querySelector("form");

    this.form.addEventListener("submit", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.form.querySelector("[data-variant-id]").value;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Handle success
          console.log("Item added to cart:", data);
          
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );

          document.querySelector("[aria-controls='cart-drawer']").click();
        })
        .catch((error) => {
          // Handle error
          console.error("Error:", error);
        });
    });
  }

  initProductOptions() {
    this.productOptions = this.querySelectorAll("[data-product-option]");

    this.productOptions.forEach((select) => {
      select.addEventListener("change", () => {
        const selectedOptions = Array.from(this.productOptions).map(
          (select) => select.value
        );

        fetch(`/products/${this.getAttribute("data-handle")}.js`)
          .then((response) => response.json())
          .then((product) => {
            const matchingVariant = product.variants.find((variant) =>
              variant.options.every(
                (option, index) => option === selectedOptions[index]
              )
            );

            if (matchingVariant) {
              this.querySelector("[data-variant-id]").value =
                matchingVariant.id;
            }
          });
      });
    });
  }
}

customElements.define("inspiration-slider-quick-buy", InspirationSliderQuickBuy);